var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5A.5.5 0 0014 4H7.5L6 2.5H2a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V4.5z",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7h4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgNC41QzE0LjUgNC4yMjM4NiAxNC4yNzYxIDQgMTQgNEg3LjVMNiAyLjVIMi4wMDAwMUMxLjcyMzg2IDIuNSAxLjUwMDAxIDIuNzIzODYgMS41MDAwMSAzVjEzQzEuNTAwMDEgMTMuMjc2MSAxLjcyMzg3IDEzLjUgMi4wMDAwMSAxMy41SDE0QzE0LjI3NjEgMTMuNSAxNC41IDEzLjI3NjEgMTQuNSAxM1Y0LjVaIiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNCA3TDggNyIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgIconFolder as ReactComponent };